import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@shadcn/components/ui/dialog";
import { Button } from "@shadcn/components/ui/button";
import { Checkbox } from "@shadcn/components/ui/checkbox";
import { useState } from "react";

export default function SelectItemsModal({ 
  isOpen, 
  onClose, 
  orderItems,
  onConfirm,
  getVariant 
}) {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleItemSelect = (item, checked) => {
    if (checked) {
      setSelectedItems(prev => [...prev, item]);
    } else {
      
      setSelectedItems(prev => prev.filter(i => i._id !== item._id));
    }
  };

  const handleConfirm = () => {
    onConfirm(selectedItems);
    setSelectedItems([]); // Reset selected items
  };

  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] sm:w-[90vw] md:w-[75vw] lg:w-[60vw] max-w-2xl p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle className="text-lg sm:text-xl">Select Items for Warranty Claim</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-3 my-3 sm:my-4 max-h-[50vh] sm:max-h-[60vh] overflow-y-auto">
          {orderItems?.map((item, index) => (
            <div key={item._id || index} className="flex items-start sm:items-center space-x-2 sm:space-x-4 p-3 sm:p-4 border rounded">
              <Checkbox
                checked={selectedItems.some(selected => selected._id === item._id)}
                onCheckedChange={(checked) => handleItemSelect(item, checked)}
                className="mt-1 sm:mt-0"
              />
              
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 flex-1">
                <img 
                  src={getVariant(item.sku)?.image} 
                  alt="" 
                  className="w-12 h-12 sm:w-16 sm:h-16 object-contain"
                />
                <div className="min-w-0">
                  <h4 className="font-medium text-sm sm:text-base truncate">{getVariant(item.sku)?.name}</h4>
                  <p className="text-xs sm:text-sm text-gray-600">SKU: {item.sku}</p>
                  <p className="text-xs sm:text-sm text-gray-600">Quantity: {item.quantity}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end space-x-2 pt-3 sm:pt-4 border-t">
          <Button variant="outline" onClick={onClose} size="sm" className="sm:size-default">Cancel</Button>
          <Button onClick={handleConfirm} size="sm" className="sm:size-default">Confirm Selection</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
